import { Workflow } from "lucide-react";
import type { ModuleSpec } from "../types";

export const workflowsSpec: ModuleSpec = {
  id: "workflows",
  icon: Workflow,
  i18n: {
    namespace: "modules",
    titleKey: "workflows.title",
    descriptionKey: "workflows.description",
  },
  nav: {
    path: "/workflows",
    group: "build",
    order: 10,
  },
  permission: {
    action: "read",
    subject: "workflow",
  },
  meta: {
    status: "active",
    description: "Automate your business processes",
  },
};
